
import { Component, Watch } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { email, minValue, required } from 'vuelidate/lib/validators';
import { Action, Getter } from 'vuex-class';

import BaseService from '@/core/components/BaseService.vue';
import Iframe from '@/core/components/Iframe.vue';
import { formatDate, formatDateChoice,mdiSvg, nameRoutes, PhoneTools } from '@/core/tools';

import LoginModal from '../../core/components/LoginModal.vue'
import {BookingConfiguration, CountBooking, MultipleBooking,MultipleBookingFormInt, Slot } from '../interfaces';
import {
  formatBookingDate,
  isClosedDate,
  isClosedDay,
  isFullDay,
  onBookableDays,
} from '../tools';

@Component({
  components: { Iframe, LoginModal },
  mixins: [validationMixin],
  validations: {
    form: {
      firstName: { required },
      lastName: { required },
      email: { required, email },
      mobile: { required,
        isValid(mobile: string) {
          if (mobile) {
            const mobileNumber = new PhoneTools(mobile, 'FR');
            return mobileNumber.isValid();
          }
          return false;
        },
      },
      comment: {},
      seats: { required, minValue: minValue(1),},
    },
  },
})
export default class MultipleBookingForm extends BaseService {
  @Action('countBookings', { namespace: 'booking' }) getCountBookings!: (params: {
    customerId: string;
    date: string;
  }) => void;

  @Action('getNotBookableDates', { namespace: 'booking' }) getNotBookableDates!: (params: {
    customerId: string;
    slotStartTime: string;
    seatsReq: number;
  }) => void;





  @Action('reset', { namespace: 'booking' }) reset!: () => void;

  @Action('changeStep', { namespace: 'booking' }) changeStep!: (step: number) => void;

  @Action('sendMultipleBooking', { namespace: 'booking' }) sendMultipleBooking!: (multipleBooking: MultipleBooking) => void;

  @Getter('bookingConfig', { namespace: 'booking' }) bookingConfig!: BookingConfiguration;

  @Getter('countBookings', { namespace: 'booking' }) countBookings!: CountBooking[];

  @Getter('notBookableDates', { namespace: 'booking' }) notBookableDates!: string[];

  @Getter('error', { namespace: 'booking' }) error!: boolean;

  @Getter('errorMessage', { namespace: 'booking' }) errorMessage!: string;

  @Getter('loading', { namespace: 'booking' }) loading!: boolean;

  @Getter('response', { namespace: 'booking' }) response!: boolean;

  @Watch('seatsReq') onSeatsChange(newValue: number, oldValue: number): void {
    if (
      this.seatsReq !== null &&
      this.seatsReq >= 0 &&
      newValue &&
      newValue !== oldValue && 
      this.selectedSlot) {
      this.getNotBookableDates({customerId: this.customerId, slotStartTime: this.selectedSlot.startTime, seatsReq: newValue})
    }
  }

  svgIcons = mdiSvg;

  dialog = false;

  stepReservation = 1;

  stepPanel = 0;

  today = new Date(Date.now()).toISOString();

  form :MultipleBookingFormInt = {
    customerId: '',
    dates: [],
    slot: '',
    seats: 0,
    lastName: '',
    firstName: '',
    mobile: '',
    email: '',
    comment: '',
    guestId: '',
  };

  isIncrementActive = false;

  isDecrementActive = false;

  valid = false;

  selectedSlot: Slot | null | undefined = null;

  routes = nameRoutes;

  firstnameLocaleStorage = window.localStorage.getItem('firstname');

  lastnameLocaleStorage = window.localStorage.getItem('lastname');

  validatedSeatsSelection = false;

  mounted() :void{
    this.login();
    this.form.firstName = window.localStorage.getItem('firstname') || ''
    this.form.lastName = window.localStorage.getItem('lastname') || ''

    if (this.bookingConfig && this.bookingConfig.slots.filter((s) => !s.disabled).length === 1){
      this.selectedSlot = this.bookingConfig.slots.filter((s) => !s.disabled).at(0)
      this.stepPanel = 1
      if (this.selectedSlot){
        this.form.slot = this.selectedSlot.startTime
      }
    }
  }

  set selectedDate(value: string[]) {
    this.form.dates = value;
  }

  get selectedDate(): string[] {
    return this.form.dates;
  }

  set seatsReq(value: number) {
    this.form.seats = value
  }

  get seatsReq(): number {
    return this.form.seats
  }

  getFormatDate = function getFormatDate(date: string): string {
    return formatDate(date)
  }

  getFormatDates = function getFormatDates(dates: string[]): string[] {
    const formatedDates :string[] = []
    dates.forEach(date => {
      formatedDates.push(formatDate(date))
    });
    return formatedDates;
  }

  getFormatMonths = function getFormatMonths(dates: string[]): string {
    let MonthsArray = dates.map(date => formatDateChoice(date, '{month}'))
    MonthsArray = [...new Set(MonthsArray)]
    const Months = MonthsArray.join(" - ")
    return Months
  }

  allowedDates(date: string): boolean {

    return (
      !isClosedDay(this.bookingConfig.workingDays)(date) &&
      !isClosedDate(this.bookingConfig.closedDates)(date) &&
      !isFullDay(this.notBookableDates)(date) &&
      onBookableDays(date, this.bookingConfig.bookableDays) &&
      this.hasSlotStarted(date)
    );
  }

  resetDatePicker() :void{
    this.selectedDate = [];
  }

  onSelectSlot(slot: Slot): void {
    this.selectedSlot = slot;
    this.form.slot = `${slot.startTime}`;
    //       this.form.slot = `${slot.startTime}-${slot.endTime}`;
    this.form.seats = 0;
    this.stepPanel = 1;
  }

  hasSlotStarted(date : string): boolean{
    const now = new Date() 
    if(this.selectedSlot && date === now.toISOString().slice(0,10)){
      const slotDate = new Date()
      const slotHours = parseInt(this.selectedSlot.startTime.split(":")[0], 10)
      const slotMinutes = parseInt(this.selectedSlot.startTime.split(":")[1], 10)
      slotDate.setHours(slotHours)
      slotDate.setMinutes(slotMinutes)

      return now < slotDate
    }
    return true
  }



  decrement(): void {
    this.form.seats -= 1;
    if (this.form.seats > 0) {
      this.isDecrementActive = true;
      this.isIncrementActive = false;
      setTimeout(() => {
        this.isDecrementActive = false;
      }, 1000);
    } else {
      this.isDecrementActive = false;
    }
  }
  
  increment(): void {
    this.form.seats += 1;
    if (this.selectedSlot && this.form.seats < this.selectedSlot.seats) {
      this.isIncrementActive = false;
    } else {
      this.isIncrementActive = true;
    }
  }

  isSeatsSelectionPanelValid(seats: number) :boolean {
    if (!this.selectedSlot){return true}
    if (seats <= this.selectedSlot.seatsThreshold && seats >= 1 && this.validatedSeatsSelection === true ) {
      return false
    }
    return true
  }

  validateSeatsSelectionPanel() :boolean | void {
    if (!this.validatedSeatsSelection) {
    this.validatedSeatsSelection = true
    }
  }

  validateStepPanel(step: number): void {
    this.stepPanel = step;
  }

  updateStep(step: number): void {
    this.stepReservation = step;
    this.changeStep(this.stepReservation);
  }

  setCurrentGuest() :void {
    this.form.email = this.email
    this.form.guestId = this.userId.toString()
  }

  nameErrors(prop: string): string[] {
    const errors: string[] = [];
    if (!this.$v.form[prop]?.$dirty) return errors;
    if (!this.$v.form[prop]?.required) errors.push('Ce champ est obligatoire');
    return errors;
  }

  emailErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.form.email?.$dirty) return errors;
    if (!this.$v.form.email?.email) errors.push("L'email doit être valide");
    if (!this.$v.form.email?.required) errors.push('Ce champ est obligatoire');
    if(this.form.email !== this.email) errors.push("L'adresse email n'est pas modifiable")
    return errors;
  }

  mobileErrors(): string[] {
    const errors: string[] = [];
    if (!this.$v.form.mobile?.$dirty) return errors;
    if (this.$v.form.mobile?.$model && !this.$v.form.mobile?.isValid) {
      errors.push('Le numéro de téléphone doit être valide');
    }
    if (!this.$v.form.mobile?.required) errors.push('Ce champ est obligatoire');
    return errors;
  }

  submitForm(): void {
    if (this.selectedSlot && this.form.guestId && this.form.email === this.email) {
        const slotStartTime = this.selectedSlot.startTime
        const dates = this.form.dates.map((date) => {
          return formatBookingDate(slotStartTime, date)}
        );
        const booking: MultipleBooking = {
          customerId: this.customerId,
          dates,
          seats: this.form.seats,
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          guestId: this.form.guestId,
          mobile: this.form.mobile,
          comment: this.form.comment || undefined,
        };


        
          this.sendMultipleBooking(booking);

          setTimeout(()=>{
            this.getBookingList(this.form.email)
          },1000)
        }
    }

    dateRange(datesSelected :string[]):string | void{
      if (datesSelected.length){
        
      const finalDates : any[] = []
      datesSelected.forEach((date :string)=>{
        finalDates.push(
          {
          date : formatDateChoice(date,'{date} {month}'), 
          order : parseInt(date.split('-').join(''),10)
        })
      })
      finalDates.sort((a,b)=>{
        return a.order - b.order
      })

      const dateSorted = finalDates.map((date)=> date.date)
      
      let minDate = dateSorted.at(0)
      const maxDate = dateSorted.at(-1) || ''
      if (minDate.split(' ')[1] === maxDate.split(' ')[1]){
        minDate = minDate.split(' ')[0] || ''
      }
      return `du ${minDate} au ${maxDate}`
    }
    return ''
    }
  

  resetForm(): void {
    this.dialog = false;
    this.stepReservation = 1;
    this.isIncrementActive = false;
    this.isDecrementActive = false;
    if (this.bookingConfig.slots.filter((s) => !s.disabled).length === 1){
      this.form = {
      customerId: '',
      dates: [],
      slot: this.bookingConfig.slots.filter((s) => !s.disabled)[0].startTime,
      seats: 0,
      lastName: '',
      firstName: '',
      mobile: '',
      email: this.email,
      guestId: this.userId,
      comment: '',
      };
      this.selectedSlot = this.bookingConfig.slots.filter((s) => !s.disabled).at(0);
    this.stepPanel = 1;

    }
    else {
      this.form = {
      customerId: '',
      dates: [],
      slot: '',
      seats: 0,
      lastName: '',
      firstName: '',
      mobile: '',
      email: this.email,
      guestId: this.userId,
      comment: '',
    }
    this.selectedSlot = null;
    this.stepPanel = 0;
    }

    this.$v.$reset();
    this.reset();
    this.changeStep(1);
        this.form.firstName = window.localStorage.getItem('firstname') || ''
    this.form.lastName = window.localStorage.getItem('lastname') || ''
  }
}
